import API from 'app/services/configuration/configurationApi'
import { BusinessTripRatesConfigurationModel } from 'app/models/configuration/businessTripRatesConfigurationModel'
import { BusinessTripRatesRestoreOption } from 'app/constants/configuration/businessTripRatesRestoreOption'
import { ExchangeRateConfigurationModel } from 'app/models/configuration/exchangeRateConfigurationModel'
import { MinimumWageConfigurationModel } from 'app/models/configuration/minimumWageConfigurationModel'

/**
 * Ostatnie trzy konfiguracje czytane przez slice `configuration`.
 *
 * Slice trzymał trzynaście pól, ale reaktywnie czytały go tylko trzy ekrany ustawień:
 * stawki delegacji, kursy walut i płaca minimalna. Reszta pól była zapisywana przez
 * thunki, których nikt nie obserwował. Klucz jest per firma - w slice'ie było jedno
 * pole na wszystkie firmy, więc po przełączeniu firmy widać było przez chwilę cudzą
 * konfigurację, dopóki nie doszła nowa odpowiedź.
 */
export const businessTripRatesConfigKey = (companyId?: string | null) =>
  ['configuration', 'businessTripRates', companyId ?? null] as const

export const exchangeRateConfigKey = (companyId?: string | null) =>
  ['configuration', 'exchangeRate', companyId ?? null] as const

export const minimumWageConfigKey = (companyId?: string | null) =>
  ['configuration', 'minimumWage', companyId ?? null] as const

export const fetchBusinessTripRatesConfiguration = async (
  companyId: string,
): Promise<BusinessTripRatesConfigurationModel> => {
  const response = await API.create().getBusinessTripRatesConfiguration(
    companyId,
  )
  return response.content.data
}

export const saveBusinessTripRatesConfigurationRequest = async (
  companyId: string,
  configuration: BusinessTripRatesConfigurationModel,
): Promise<BusinessTripRatesConfigurationModel> => {
  const response = await API.create().saveBusinessTripRatesConfiguration(
    companyId,
    configuration,
  )
  return response.content.data
}

export const restoreBusinessTripRatesConfigurationRequest = async (
  companyId: string,
  restoreOption: BusinessTripRatesRestoreOption,
): Promise<BusinessTripRatesConfigurationModel> => {
  const response = await API.create().restoreBusinessTripRatesConfiguration(
    companyId,
    restoreOption,
  )
  return response.content.data
}

export const fetchExchangeRateConfiguration = async (
  companyId: string,
  rateDate: any,
  source: number,
): Promise<ExchangeRateConfigurationModel[]> => {
  const response = await API.create().getExchangeRateConfiguration(
    companyId,
    rateDate,
    source,
  )
  return response.content.data
}

export const downloadExchangeRatesRequest = async (
  companyId: string,
  dateFrom: any,
  dateTo: any,
  source: number,
) => {
  const response = await API.create().downloadExchangeRates(
    companyId,
    dateFrom,
    dateTo,
    source,
  )
  return response.content.data
}

export const fetchMinimumWageConfiguration = async (
  companyId: string,
): Promise<MinimumWageConfigurationModel> => {
  const response = await API.create().getMinimumWageConfiguration(companyId)
  return response.content.data
}

export const saveMinimumWageConfigurationRequest = async (
  companyId: string,
  configuration: MinimumWageConfigurationModel,
): Promise<MinimumWageConfigurationModel> => {
  const response = await API.create().saveMinimumWageConfiguration(
    companyId,
    configuration,
  )
  return response.content.data
}
